/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    SUBSCRIPTIONS_startingFrom: "à partir de {0}€/mois",
    SUBSCRIPTIONS_startingFromFree: "Gratuit",
    SUBSCRIPTIONS_recurrenceTitleMonthly: "Coût mensuel",
    SUBSCRIPTIONS_recurrenceTitleYearly: "Coût annuel",
    SUBSCRIPTIONS_recurrenceMonthly: "Mensuel",
    SUBSCRIPTIONS_recurrenceYearly: "Annuel",
    SUBSCRIPTIONS_recurrenceUnitMonthly: "mois",
    SUBSCRIPTIONS_recurrenceUnitYearly: "ans",

    SUBSCRIPTIONS_save: "Economisez {0}%",
    SUBSCRIPTIONS_recurrenceInvoicingMonthly: "facturé mensuellement",
    SUBSCRIPTIONS_recurrenceInvoicingYearly: "facturé annuellement",
    SUBSCRIPTIONS_cartNote: "Ceci est un message pour vous prévenir d’une information " +
        "ponctuelle...",
    SUBSCRIPTIONS_validateOffer: "Validez votre offre",

    SUBSCRIPTIONS_salesNotice: "Vous n'arrivez pas à composer votre offre ou si elle est adaptée " +
        "à votre besoin ?",

    SUBSCRIPTIONS_contactSales: "Parler à un commercial",
    SUBSCRIPTIONS_showAllFeatures: "Voir toutes les fonctionnalités",

    SUBSCRIPTIONS_title: "Abonnements",
    SUBSCRIPTIONS_label: "abonnement",
    SUBSCRIPTIONS_create: "Créer un abonnement",
    SUBSCRIPTIONS_plural_label: "abonnements",
    SUBSCRIPTIONS_splashScreenTitle: "Vous n'avez aucun abonnement pour le moment",
    SUBSCRIPTIONS_splashScreenDescription:
        "Pensez à créer des produits et visiter la page de tarification",

    SUBSCRIPTIONS_columnId: "Id",
    SUBSCRIPTIONS_columnCustomerEmail: "Email du compte",
    SUBSCRIPTIONS_columnState: "État",
    SUBSCRIPTIONS_filterPlan: "Nom de l'abonnement",
    SUBSCRIPTIONS_filterPlanPlaceholder: "Filtrer par nom d'abonnement",
    SUBSCRIPTIONS_columnLines: "Plans d'abonnement",
    SUBSCRIPTIONS_columnRecurrence: "Récurrence",
    SUBSCRIPTIONS_columnCreatedAt: "Créé le",
    SUBSCRIPTIONS_columnUpdatedAt: "Modifié le",
    SUBSCRIPTIONS_columnMonthlyTotal: "Total mensuel moyen",
    SUBSCRIPTIONS_columnYearlyTotal: "Total annuel moyen",
    SUBSCRIPTIONS_monthlyTotalValue: "{amount} {currency} HT/mois",
    SUBSCRIPTIONS_yearlyTotalValue: "{amount} {currency} HT/an",

    SUBSCRIPTION_Details: "Détails de l'abonnement",
    SUBSCRIPTION_keyInfo: "Infos clés",
    SUBSCRIPTION_companyInfo: "Infos société",
    SUBSCRIPTION_contactInfo: "Coordonnées",
    SUBSCRIPTION_monthlyPriceLabel: "Prix mensuel",
    SUBSCRIPTION_yearlyPriceLabel: "Prix annuel",
    SUBSCRIPTION_firstSubscriptionDate: "1ère souscription le",
    SUBSCRIPTION_lastUpdatedDate: "Modifié le",
    SUBSCRIPTION_recurrenceLabel: "Récurrence",
    SUBSCRIPTION_currentPeriod: "Période en cours du {0} au {1}",
    SUBSCRIPTION_nextCyclePriceNote:
        "Les tarifs affichés sont ceux appliqués au prochain cycle de facturation.",
    SUBSCRIPTION_HISTORY_link: "Historique des changements",
    SUBSCRIPTION_HISTORY_loading: "Chargement de l'historique…",
    SUBSCRIPTION_HISTORY_empty: "Aucun changement enregistré pour cet abonnement.",
    SUBSCRIPTION_HISTORY_quantity: "Quantité",
    SUBSCRIPTION_HISTORY_amount: "Prix",
    SUBSCRIPTION_HISTORY_seeMore: "voir plus",
    SUBSCRIPTION_HISTORY_seeLess: "voir moins",
    SUBSCRIPTIONAUDIT_missingSubscriptionId: "Abonnement ou client manquant.",
    SUBSCRIPTION_PRODUCTS_PLANS: "Produits et prix",
    SUBSCRIPTION_priceIncluded: "Inclus",
    SUBSCRIPTION_priceTierFree: "Inclus jusqu'à {limit}",
    SUBSCRIPTION_priceTierFreeNoLimit: "1er palier offert",
    SUBSCRIPTION_BILLING: "Facturation",
    SUBSCRIPTION_QUOTA: "Quota",
    SUBSCRIPTIONS_fieldNote: "Description",
    SUBSCRIPTIONS_fieldCoupon: "Bon de réduction",
    SUBSCRIPTION_functionalities: "Fonctionnalités incluses dans cet abonnement.",
    SUBSCRIPTIONS_unlimitedQuantity: "Illimité(e)s",

    SUBSCRIPTIONS_successTitle: "Abonnements",
    SUBSCRIPTIONS_successMessage: "Abonnement créé avec succès, merci de vérifier votre mail",

    SUBSCRIPTIONS_statusOffer: "Offre",
    SUBSCRIPTIONS_statusActive: "Actif",
    SUBSCRIPTIONS_statusIncomplete: "Incomplet",
    SUBSCRIPTIONS_statusIncompleted_Expired: "Expiré",
    SUBSCRIPTIONS_statusPastDue: "En retard",
    SUBSCRIPTIONS_statusTrial: "En cours d'essai",
    SUBSCRIPTIONS_statusTrialBadge: "Essai",
    SUBSCRIPTIONS_statusCanceled: "Résilié",
    SUBSCRIPTIONS_statusUnpaid: "Impayé",

    SUBSCRIPTION_actionUnsubscribe: "Annuler l'abonnement à la fin de période",
    SUBSCRIPTION_actionCancel: "Annuler l'abonnement immédiatement",
    SUBSCRIPTION_cancelWarning: "Attention !",
    SUBSCRIPTION_confirmCancellation: "Oui je souhaite résilier",
    SUBSCRIPTION_cancellationMessage: "Vous allez annuler l'abonnement de ce client.",
    SUBSCRIPTION_cancellationDeadlineMessage:
        "Après la résiliation la dernière facturation s'arrêtera à la date du {0}",
    SUBSCRIPTION_confirmCancellationMessage: "Vous êtes sûr ?",

    SUBSCRIPTIONS_current: "Abonnement actuel",

    SUBSCRIPTIONS_incompatiblePlan:
        "Ce plan n'est pas compatible avec les autres plans sélectionnés.",

    SUBSCRIPTIONS_recommended: "Recommandé",

    SUBSCRIPTION_download: "Télécharger",
    SUBSCRIPTION_paid: "PAYÉE",
    SUBSCRIPTION_open: "EN ATTENTE",
    SUBSCRIPTION_void: "ANNULÉE",
    SUBSCRIPTION_uncollectible: "NON-RÉGLÉE",

    SUBSCRIPTION_nextPayment: "Prochain réglement le",
    SUBSCRIPTION_cannotEndTrialForSubscription: "Ce client n'a pas d'abonnement d'essai",
    SUBSCRIPTION_actionStripeRedirection: "Rediriger vers la page d'abonnement",
    SUBSCRIPTION_unsubscribeSuccessTitle: "Notification",
    SUBSCRIPTION_unsubscribeSuccessMessage: "Votre abonnement a été programmé pour annulation",
    SUBSCRIPTION_actionChangeRecurrence: "Changer la récurrence de facturation",
    SUBSCRIPTION_confirmChangeRecurrence: "Confirmer le changement",
    SUBSCRIPTION_recurrenceMonthly: "mensuelle",
    SUBSCRIPTION_recurrenceYearly: "annuelle",
    SUBSCRIPTION_recurrencePhraseMonthly: "récurrence mensuelle",
    SUBSCRIPTION_recurrencePhraseYearly: "récurrence annuelle",
    SUBSCRIPTION_changeRecurrenceMessage:
        "La facturation de cet abonnement passera en {0}. Les éléments Stripe seront \
        remplacés sans résilier l'abonnement.",
    SUBSCRIPTION_changeRecurrenceConfirmMessage:
        "Confirmez-vous le passage manuel en {0} ?",
    SUBSCRIPTION_changeRecurrenceSuccessTitle: "Notification",
    SUBSCRIPTION_changeRecurrenceSuccessMessage: "La récurrence de l'abonnement a été modifiée",
    SUBSCRIPTIONS_stripeSubscriptionGone:
        "Cet abonnement n'existe plus chez Stripe (supprimé ou terminé) : rien n'a été modifié.",
    SUBSCRIPTIONS_recurrenceChangeRequiresActive:
        "La récurrence ne peut être modifiée que sur un abonnement actif.",
    SUBSCRIPTIONS_invalidRecurrence: "Récurrence invalide.",
    SUBSCRIPTIONS_unsubscribeConfirm: "Êtes-vous sûr de vouloir annuler cet abonnement? | \
        Êtes-vous sûr de vouloir annuler ces abonnements?",
    SUBSCRIPTIONS_recurrentPriceLine: "{subtotal} {currency} / {recurrence}",
    SUBSCRIPTIONS_globalPriceLine: "{subtotal} {currency}",
    SUBSCRIPTIONS_subscribedPlansSubtitle: "{productName} - {planName}",
    SUBSCRIPTIONS_discountActivated:
        `Cet abonnement bénéficie d'une réduction de {discountValue} sur {discountDuration} à
        compter du {discountDate}`,
    SUBSCRIPTIONS_yearlyDiscountActivated:
        "Cet abonnement bénéficie d'une réduction de {discountValue}",
    SUBSCRIPTIONS_yearlyDiscountExpired:
        "Cet abonnement a bénéficié d'une réduction de {discountValue}",
    SUBSCRIPTIONS_discountExpired:
        `Cet abonnement a bénéficié d'une réduction de {discountValue} sur {discountDuration} à
        compter du {discountDate}`,

    SUBSCRIPTIONS_migrateAllAction: "Appliquer les tarifs aux clients",
    SUBSCRIPTIONS_migrateAllConfirm:
        `Appliquer les tarifs publiés à tous les clients existants encore sur d'anciens tarifs ?
        Le nouveau tarif prendra effet au prochain cycle de facturation, sans prélèvement immédiat
        au prorata.`,
    SUBSCRIPTIONS_migrateAllTitle: "Migration des tarifs",
    SUBSCRIPTIONS_migratePlansLabel: "Plans concernés",
    SUBSCRIPTIONS_migrateSeeAccounts: "Voir les comptes concernés",
    SUBSCRIPTIONS_migrateApplyTo: "Appliquer à {count} compte(s)",
    SUBSCRIPTIONS_migrateBackToPlans: "‹ Retour aux plans",
    SUBSCRIPTIONS_migrateAccountsHelp:
        "Comptes encore sur d'anciens tarifs. Montants hors taxes, par mois ou par an "
        + "selon leur récurrence. Le nouveau tarif part à la prochaine échéance. Décochez "
        + "ceux à laisser sur leur tarif actuel.",
    SUBSCRIPTIONS_migrateAccountsLoading: "Calcul des montants…",
    SUBSCRIPTIONS_migrateAccountsEmpty:
        "Aucun compte à migrer : tous sont déjà aux tarifs publiés.",
    SUBSCRIPTIONS_migrateAccountsSearch: "Rechercher une société",
    SUBSCRIPTIONS_migrateAccountsCount: "{selected} / {total} sélectionné(s)",
    SUBSCRIPTIONS_migrateColCustomer: "Société",
    SUBSCRIPTIONS_migrateColPlan: "Plan",
    SUBSCRIPTIONS_migrateColRecurrence: "Récurrence",
    SUBSCRIPTIONS_migrateColNext: "Prochaine échéance",
    SUBSCRIPTIONS_migrateColAmount: "Avant → après (HT)",
    SUBSCRIPTIONS_migrateAllDone: "{count} abonnement(s) migré(s) vers les tarifs actuels",
    SUBSCRIPTIONS_migrateAllStarting: "Migration en cours…",
    SUBSCRIPTIONS_migrateAllProgress:
        "Migration en cours… {examined}/{total} abonnement(s) traité(s), {migrated} migré(s)",
    SUBSCRIPTIONMIGRATION_title: "Historique des migrations de tarifs",
    SUBSCRIPTIONMIGRATION_loading: "Chargement de l'historique…",
    SUBSCRIPTIONMIGRATION_empty: "Aucune migration enregistrée",
    SUBSCRIPTIONMIGRATION_filterAll: "Tous",
    SUBSCRIPTIONMIGRATION_filterMigrated: "Migrés",
    SUBSCRIPTIONMIGRATION_filterFailed: "Échecs",
    SUBSCRIPTIONMIGRATION_filterSkipped: "Ignorés",
    SUBSCRIPTIONMIGRATION_filterUpToDate: "Déjà à jour",
    SUBSCRIPTIONMIGRATION_filterOutOfScope: "Hors scope",
    SUBSCRIPTIONMIGRATION_statusMigrated: "Migré",
    SUBSCRIPTIONMIGRATION_statusFailed: "Échec",
    SUBSCRIPTIONMIGRATION_statusSkipped: "Ignoré",
    SUBSCRIPTIONMIGRATION_statusUpToDate: "Déjà à jour",
    SUBSCRIPTIONMIGRATION_statusOutOfScope: "Hors scope",
    SUBSCRIPTIONMIGRATION_explainMigrated: "Cet abonnement était sur d'anciens prix. La "
        + "migration l'a repositionné sur les prix du plan en vigueur et l'a refacturé. Le "
        + "détail ci-dessous montre l'avant / après (les prix globaux ne sont pas concernés).",
    SUBSCRIPTIONMIGRATION_explainUpToDate: "Cet abonnement était déjà sur les prix du plan en "
        + "vigueur. Rien à migrer, aucune refacturation (les prix globaux ne sont pas concernés).",
    SUBSCRIPTIONMIGRATION_explainSkipped: "Abonnement impossible à migrer : son équivalent "
        + "Stripe est annulé ou absent. Aucune relance ne peut le corriger.",
    SUBSCRIPTIONMIGRATION_explainFailed: "La migration a échoué sur une erreur récupérable. "
        + "Le bouton Relancer rejoue la migration.",
    SUBSCRIPTIONMIGRATION_explainOutOfScope: "Abonnement non concerné par ce run : non actif, "
        + "ou sans ligne sur les plans sélectionnés.",
    SUBSCRIPTIONMIGRATION_colDate: "Date",
    SUBSCRIPTIONMIGRATION_colSubscription: "Abonnement",
    SUBSCRIPTIONMIGRATION_colCustomer: "Client",
    SUBSCRIPTIONMIGRATION_colStatus: "Statut",
    SUBSCRIPTIONMIGRATION_colReason: "Raison",
    SUBSCRIPTIONMIGRATION_count: "{total} ligne(s)",
    SUBSCRIPTIONMIGRATION_previous: "Précédent",
    SUBSCRIPTIONMIGRATION_next: "Suivant",
    SUBSCRIPTIONMIGRATION_pageOf: "Page {page} / {pages}",
    SUBSCRIPTIONMIGRATION_tab: "Migration",
    SUBSCRIPTIONMIGRATION_colAction: "Action",
    SUBSCRIPTIONMIGRATION_showDetail: "Détail",
    SUBSCRIPTIONMIGRATION_hideDetail: "Masquer",
    SUBSCRIPTIONMIGRATION_retry: "Relancer",
    SUBSCRIPTIONMIGRATION_retrying: "Relance…",
    SUBSCRIPTIONMIGRATION_retryTitle: "Relance de migration",
    SUBSCRIPTIONMIGRATION_retryDone: "Abonnement migré vers les tarifs actuels",
    SUBSCRIPTIONMIGRATION_retryFailed: "La migration a de nouveau échoué",
    SUBSCRIPTIONMIGRATION_detailRecurrence: "Récurrence :",
    SUBSCRIPTIONMIGRATION_detailLine: "Ligne",
    SUBSCRIPTIONMIGRATION_detailBefore: "Avant",
    SUBSCRIPTIONMIGRATION_detailAfter: "Après",
    SUBSCRIPTIONMIGRATION_detailTotal: "Total",
    SUBSCRIPTIONMIGRATION_included: "Inclus jusqu'à {quantity}"
}
